import React from 'react';

function LogoCard({ logoUrl }) {
    return (
        <div className="notifications-panel">
            <div className="notifications-panel__header">
                <i className="bi bi-card-image"></i>
                Logo
            </div>
            <div className="notifications-panel__body">
                {logoUrl ? (
                    <div className="clinic-info-logo-wrap">
                        <img src={logoUrl} className="img-fluid" alt="Clinic logo" />
                    </div>
                ) : (
                    <div className="notifications-empty-state py-3">
                        <i className="bi bi-image"></i>
                        No logo uploaded.
                    </div>
                )}
            </div>
        </div>
    );
}

export default LogoCard;
